export default __webpack_public_path__ + "static/media/logo.3c3837ff.png";